import {front} from 'app/api/CirrusApi';

export class BillingApiService {
  static async setPayment(teamId: string, data: Contracts.Billing.SetPayment): Promise<void> {
    return front.teams(teamId).billing().plan().put(data);
  }

  static async switchToInvoice(teamId: string, data: Contracts.Billing.SwitchToInvoice) {
    return front.teams(teamId).billing().switch_to_ibb().post(data);
  }

  static async cancelInvoiceRequest(teamId: string): Promise<void> {
    return front.teams(teamId).billing().cancel_switch_to_ibb().post();
  }

  static async getEdgePlan(teamId: string): Promise<Contracts.Billing.Cloud.Plan> {
    return front.teams(teamId).billing().plan().get();
  }
}
